/* Petal Post: tag-driven extras for product pages.
   pp-no-vessel : hides the vase add-on (the basket or vessel is already included).
   pp-rose-choice : adds a Roses choice (standard or spray), saved on the order line and in quote requests.
   seen-on-ig : sold as photographed. No product-page add-ons and no quote card. Add to cart orders the one pictured.
     A second button, Make it for your budget, opens a budget box (minimum $100); that order is saved with the Budget.
   pp-budget : 'as big as possible' shows a short note about cheaper flowers and more greenery.
   Bouquets and baskets: the quote card asks about budget (minimum $100, or $80 on Florist's Choice).
   Rose, tulip and peony by-the-stem products: a required colour choice, saved on the order line as Colour.
   Quote and request forms reuse the Delivery or pickup date box instead of asking for the date again. */
(function () {
  var root = document.getElementById('petal-options');
  if (!root) return;
  var data;
  try { data = JSON.parse(root.querySelector('script[data-pp-data]').textContent); } catch (e) { return; }
  var tags = data.tags || [];
  function has(t) { return tags.indexOf(t) !== -1; }

  if (has('seen-on-ig')) {
    var ids = ['pp-vessel-block', 'pp-shape-group', 'pp-bqgreen', 'pp-bqgreen-price', 'pp-luxe', 'pp-orchid', 'pp-orchid-fields', 'pp-breath', 'pp-breath-fields', 'pp-letters', 'pp-letters-fields', 'pp-ribbon', 'pp-ribbon-fields', 'pp-quote'];
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var holder = el.closest('label') || el;
      if (holder.id === 'pp-quote' || holder.parentNode) holder.remove();
    });
    var greenGroup = root.querySelector('input[name="pp-green"]');
    if (greenGroup) { var g = greenGroup.closest('.pp-group'); if (g) g.remove(); }
    root.querySelectorAll('.pp-sub').forEach(function (s) { s.remove(); });
    root.querySelectorAll('.pp-quote').forEach(function (q) { q.remove(); });
  }

  var vsel = document.getElementById('pp-vessel');
  if (vsel) {
    var bo = vsel.querySelector('option[value="Basket"]');
    if (bo) bo.remove();
    var vl = vsel.closest('label');
    if (vl && vl.firstChild && vl.firstChild.nodeType === 3) vl.firstChild.textContent = 'Vase or hat box ';
  }

  if (has('pp-no-vessel')) {
    var vb = document.getElementById('pp-vessel-block');
    if (vb) vb.remove();
  }

  if (has('pp-budget')) {
    var bigBox = document.getElementById('pp-big');
    if (bigBox) {
      var bl = bigBox.closest('label');
      var bigNote = document.createElement('p');
      bigNote.className = 'pp-note';
      bigNote.id = 'pp-big-note';
      bigNote.hidden = true;
      bigNote.textContent = 'We will use cheaper flowers and more greenery to make it as big as possible for your budget.';
      if (bl) bl.insertAdjacentElement('afterend', bigNote);
      var syncBig = function () { bigNote.hidden = !bigBox.checked; };
      bigBox.addEventListener('change', syncBig);
      syncBig();
    }
  }

  if (data.type === 'Bouquet' && !has('seen-on-ig')) {
    var eb = document.querySelector('.pp-quote-eyebrow');
    var ld = document.querySelector('.pp-quote-lead');
    var bi = document.getElementById('pp-q-budget');
    var minTxt = has('pp-budget') ? '$80' : '$100';
    if (eb) eb.textContent = 'Have a set budget?';
    if (ld) ld.textContent = 'Tell us and we’ll design to it. Our minimum budget is ' + minTxt + '. Nothing is charged until we agree on your design.';
    if (bi) bi.placeholder = 'Minimum ' + minTxt + ', e.g. $250';
  }

  if (has('seen-on-ig')) {
    var atc = document.querySelector('form[data-type="add-to-cart-form"]');
    if (atc && !document.getElementById('pp-seen-budget')) {
      var wrap = document.createElement('div');
      wrap.id = 'pp-seen-budget';
      wrap.className = 'pp-seen-budget';
      wrap.style.marginTop = '1.2rem';
      wrap.innerHTML =
        '<button type="button" class="button button--secondary button--full-width" id="pp-seen-open">Make it for your budget</button>' +
        '<div id="pp-seen-panel" hidden style="margin-top:1.2rem">' +
        '<label class="pp-label" for="pp-seen-budget-input">Your budget</label>' +
        '<p class="pp-note">Tell us your budget and we will make it work. Our minimum is $100.</p>' +
        '<input type="text" id="pp-seen-budget-input" inputmode="numeric" maxlength="12" placeholder="e.g. $250" style="display:block;width:100%;margin:.4rem 0 1rem;padding:.9rem 1.1rem;font:inherit;border:1px solid rgba(156,74,104,.4);background:transparent;color:inherit;box-sizing:border-box">' +
        '<p class="pp-error" id="pp-seen-budget-error" role="alert" hidden></p>' +
        '<button type="button" class="button button--full-width" id="pp-seen-go">Add to cart for my budget</button></div>';
      atc.insertAdjacentElement('afterend', wrap);
    }
    var seenBudget = null;
    var budgetMode = false;
    var openBtn = document.getElementById('pp-seen-open');
    var panel = document.getElementById('pp-seen-panel');
    var goBtn = document.getElementById('pp-seen-go');
    if (openBtn && panel) {
      openBtn.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        if (!panel.hidden) { var i = document.getElementById('pp-seen-budget-input'); if (i) i.focus(); }
      });
    }
    if (goBtn) {
      goBtn.addEventListener('click', function () {
        var inp = document.getElementById('pp-seen-budget-input');
        var err = document.getElementById('pp-seen-budget-error');
        var n = inp ? parseFloat(String(inp.value).replace(/[^0-9.]/g, '')) : NaN;
        var msg = '';
        if (isNaN(n)) msg = 'Please tell us your budget.';
        else if (n < 100) msg = 'Our minimum budget is $100.';
        if (err) { err.textContent = msg; err.hidden = !msg; }
        if (msg) { if (inp) inp.focus(); return; }
        seenBudget = '$' + Math.round(n);
        budgetMode = true;
        var f = document.querySelector('form[data-type="add-to-cart-form"]');
        if (f && f.requestSubmit) f.requestSubmit(); else if (f) f.submit();
      });
    }
    window.addEventListener('submit', function (e) {
      var f = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!f || e.target !== f) return;
      if (!budgetMode) seenBudget = null;
      budgetMode = false;
    }, true);
    var origFetchSeen = window.fetch;
    window.fetch = function (u, o) {
      try {
        if (seenBudget && typeof u === 'string' && u.indexOf('/cart/add') !== -1 && o && typeof o.body === 'string') {
          var b = JSON.parse(o.body);
          if (b.items && b.items[0]) {
            b.items[0].properties = b.items[0].properties || {};
            b.items[0].properties['Budget'] = seenBudget;
            o = Object.assign({}, o, { body: JSON.stringify(b) });
          }
        }
      } catch (e) { /* send the original request */ }
      return origFetchSeen.call(this, u, o);
    };
  }

  if (has('pp-rose-choice')) {
    var notes = document.getElementById('pp-notes');
    var anchor = notes && notes.closest('label');
    if (anchor && !document.getElementById('pp-rose-group')) {
      anchor.insertAdjacentHTML('beforebegin',
        '<div class="pp-group" id="pp-rose-group"><span class="pp-label">Roses</span>' +
        '<label class="pp-radio"><input type="radio" name="pp-roses" value="" checked> <span>No preference</span></label>' +
        '<label class="pp-radio"><input type="radio" name="pp-roses" value="Standard roses"> <span>Standard roses</span></label>' +
        '<label class="pp-radio"><input type="radio" name="pp-roses" value="Spray roses"> <span>Spray roses</span></label></div>');
    }
    var choice = function () {
      var e = document.querySelector('input[name="pp-roses"]:checked');
      return e ? e.value : '';
    };
    var origFetch = window.fetch;
    window.fetch = function (u, o) {
      try {
        if (typeof u === 'string' && u.indexOf('/cart/add') !== -1 && o && typeof o.body === 'string' && choice()) {
          var b = JSON.parse(o.body);
          if (b.items && b.items[0]) {
            b.items[0].properties = b.items[0].properties || {};
            b.items[0].properties['Roses'] = choice();
            o = Object.assign({}, o, { body: JSON.stringify(b) });
          }
        }
      } catch (e) { /* send the original request */ }
      return origFetch.call(this, u, o);
    };
    var origSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (this.id === 'pp-quote-form' && choice()) {
        var i = this.querySelector('[data-pp-f="body"]');
        if (i) i.value += '\nRoses: ' + choice();
      }
      return origSubmit.call(this);
    };
  }

  var colourSets = {
    'roses-en-masse': 'Rose',
    'reflexed-roses-en-masse': 'Rose',
    'baby-roses-en-masse': 'Rose',
    'tulips-en-masse': 'Tulip',
    'peonies-en-masse': 'Peony'
  };
  if (colourSets[data.handle]) {
    var isRose = colourSets[data.handle] === 'Rose';
    var cNotes = document.getElementById('pp-notes');
    var cAnchor = cNotes && cNotes.closest('label');
    if (cAnchor && !document.getElementById('pp-colour-group')) {
      var cols = isRose
        ? [['Red', 'Red (most popular)'], ['Light pink', 'Light pink (popular)'], ['Dark pink', 'Dark pink (popular)'], ['White', 'White'], ['Purple', 'Purple'], ['Yellow', 'Yellow'], ['Orange', 'Orange'], ['Mixed', 'Mixed colours (tell us in the notes)']]
        : [['Pink', 'Pink'], ['Coral', 'Coral'], ['White', 'White'], ['Burgundy', 'Burgundy']];
      var opts = '<option value="">Choose a colour</option>';
      cols.forEach(function (c) { opts += '<option value="' + c[0] + '">' + c[1] + '</option>'; });
      cAnchor.insertAdjacentHTML('beforebegin',
        '<div class="pp-group" id="pp-colour-group"><label class="pp-label" for="pp-colour">' + colourSets[data.handle] + ' colour</label>' +
        '<select id="pp-colour" style="display:block;width:100%;margin-top:.4rem;padding:.9rem 1.1rem;font:inherit;border:1px solid rgba(156,74,104,.4);background:transparent;color:inherit;box-sizing:border-box">' + opts + '</select>' +
        '<p class="pp-error" id="pp-colour-error" role="alert" hidden>Please choose a colour.</p></div>');
    }
    var colSel = document.getElementById('pp-colour');
    var colErr = document.getElementById('pp-colour-error');
    if (colSel) {
      colSel.addEventListener('change', function () { if (colErr) colErr.hidden = true; });
      window.addEventListener('submit', function (e) {
        var f = document.querySelector('form[data-type="add-to-cart-form"]');
        if (!f || e.target !== f) return;
        var req = document.getElementById('pp-req-flowers');
        if (req && req.value.trim()) return;
        if (!colSel.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (colErr) colErr.hidden = false;
          colSel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          colSel.focus();
        }
      }, true);
      var origFetchCol = window.fetch;
      window.fetch = function (u, o) {
        try {
          if (colSel.value && typeof u === 'string' && u.indexOf('/cart/add') !== -1 && o && typeof o.body === 'string') {
            var b = JSON.parse(o.body);
            if (b.items && b.items[0]) {
              b.items[0].properties = b.items[0].properties || {};
              b.items[0].properties['Colour'] = colSel.value;
              o = Object.assign({}, o, { body: JSON.stringify(b) });
            }
          }
        } catch (e) { /* send the original request */ }
        return origFetchCol.call(this, u, o);
      };
      var origSubmitCol = HTMLFormElement.prototype.submit;
      HTMLFormElement.prototype.submit = function () {
        if (this.id === 'pp-quote-form' && colSel.value) {
          var i = this.querySelector('[data-pp-f="body"]');
          if (i) i.value += '\nColour: ' + colSel.value;
        }
        return origSubmitCol.call(this);
      };
    }
  }

  /* Quote and request forms: use the Delivery or pickup date box instead of asking for the date twice. */
  function syncDates() {
    var src = document.getElementById('pp-date-input');
    ['pp-req-date', 'pp-q-date'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var lab = el.closest('label');
      if (lab) lab.style.display = 'none';
      if (src && src.value) {
        var d = new Date(src.value + 'T00:00:00');
        el.value = d.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      } else {
        el.value = '';
      }
    });
    var pe = document.getElementById('pp-error');
    if (pe && pe.textContent.indexOf('date you need it') !== -1) pe.textContent = 'Please choose your delivery or pickup date above.';
  }
  setInterval(syncDates, 300);
})();
